import dayjs from "dayjs";
import { atom, useAtom, useSetAtom } from "jotai";
import { nanoid } from "nanoid";

export const spotlightInputAtom = atom({
    show: false,
    data: {},
});

export const spotlightResultsAtom = atom({
    show: false,
    type: null, // preset, calendar, trend
    data: {},
});

export const useSpotlightSearch = () => {
    const setResults = useSetAtom(spotlightResultsAtom);

    function search(query) {
        switch (query) {
            case "preset":
                setResults({
                    show: true,
                    type: "preset",
                    data: {
                        preset: "did_you_know",
                    },
                });
                break;
            case "festival":
                setResults({
                    show: true,
                    type: "festival",
                    data: {
                        tag: "diwali",
                    },
                });
                break;
            case "today":
                setResults({
                    show: true,
                    type: "calendar",
                    data: {
                        dt: dayjs().format("YYYY-MM-DD"),
                    },
                });
                break;
            case "tomorrow":
                setResults({
                    show: true,
                    type: "calendar",
                    data: {
                        dt: dayjs().add(1, "day").format("YYYY-MM-DD"),
                    },
                });
                break;
            case "now":
            case "trend":
            case "trending":
                setResults({
                    show: true,
                    type: "trend",
                    data: {
                        dt: dayjs().format("YYYY-MM-DD"),
                    },
                });
                break;
            default:
                setResults({
                    show: true,
                    type: query,
                    data: {},
                });
        }
    }

    return {
        search,
    };
};
